
const Next = ({isActive = false})=>{
return <svg width="9" height="13" viewBox="0 0 9 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.840088 2.0057L5.42009 6.5957L0.840088 11.1857L2.25009 12.5957L8.25009 6.5957L2.25009 0.595703L0.840088 2.0057Z" fill={isActive? "#FFFFFF":"#A1B6BA"}/>
</svg>

}

export default Next